import LogoIessa from "@/assets/logo-iessa-new.png";

const SobreInstituto = () => {
  return <section className="section-shell">
      <header className="mb-10 max-w-3xl space-y-3">
        <p className="section-title">Sobre o Instituto</p>
        <h1 className="section-heading">Uma casa de ensino, cuidado e envio.</h1>
        <p className="section-subtitle">
          O Instituto Evangelístico e Social Sabedoria do Alto surge do coração de uma igreja evangélica que sonha com
          um espaço dedicado à formação, à missão e ao serviço à sociedade.
        </p>
      </header>

      <div className="grid gap-10 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-start">
        <article className="space-y-4">
          <h2 className="text-2xl font-semibold">Ligação com a igreja local.</h2>
          <p className="text-sm text-muted-foreground">
            O Instituto está ligado a uma igreja evangélica comprometida com a pregação expositiva da Palavra, a vida
            em comunidade e o cuidado pastoral. Cada projeto é pensado em diálogo com a liderança e com o conselho da
            igreja, para que caminhemos em unidade.
          </p>

          <p className="text-sm text-muted-foreground">
            Não somos uma organização isolada, mas uma extensão da vida da igreja, servindo para formar, enviar e apoiar
            pessoas e ministérios.
          </p>

          <section className="mt-6 space-y-4">
            <div className="space-y-2">
              <h3 className="text-lg font-semibold">Logos e identidade.</h3>
              <p className="text-sm text-muted-foreground">
                A marca do Instituto combina elementos de ensino (o livro aberto), serviço (as mãos estendidas) e
                esperança (o horizonte em tons de azul). Ela representa nossa confiança na sabedoria que vem do alto.
              </p>
            </div>

            <div className="flex justify-center">
              <img
                src={LogoIessa}
                alt="Logotipo do Instituto Evangelístico e Social Sabedoria do Alto"
                className="h-28 w-auto drop-shadow-sm"
                loading="lazy"
                width={112}
                height={112}
              />
            </div>
          </section>
        </article>

        <aside className="card-ambient p-6 space-y-4">
          <h2 className="text-lg font-semibold">Linha do tempo </h2>
          <ol className="space-y-4 text-sm text-muted-foreground">
            <li>
              <div>
                <strong>2019</strong> – Início das atividades
              </div>
              <p className="mt-1">
                O IESSA começa suas ações de evangelismo e apoio social, fortalecendo pequenas igrejas por meio da
                educação teológica básica.
              </p>
            </li>
            <li>
              <div>
                <strong>2020–2021</strong> – Expansão
              </div>
              <p className="mt-1">
                O Instituto amplia projetos missionários e sociais, consolidando parcerias com comunidades e igrejas
                locais.
              </p>
            </li>
            <li>
              <div>
                <strong>2022</strong> – Fortalecimento institucional
              </div>
              <p className="mt-1">
                Com a fundação da Igreja Fraternal, o IESSA estrutura suas atividades e intensifica a formação teológica.
              </p>
            </li>
            <li>
              <div>
                <strong>2023–2024</strong> – Crescimento e impacto
              </div>
              <p className="mt-1">
                O curso teológico livre ganha destaque. Mais de 100 alunos já concluíram a formação oferecida pelo
                Instituto.
              </p>
            </li>
          </ol>
        </aside>
      </div>
    </section>;
};
export default SobreInstituto;